class DeliveryOptionsService {
    constructor(restangular, bootstrap, shopperService) {
        this.shopperService = shopperService;

        this.api = restangular.one('Delivery');
        this.options = {};
        this.hasPhoneReVerified = false;
        this.hasPhoneSubmittedForVerification = false;

        if (bootstrap.isBootstrapped(bootstrap.bootstrapped.DeliveryInfo)) {
            this.options.DeliveryInstructions = bootstrap.getBootstrappedData(bootstrap.bootstrapped.DeliveryInfo).DeliveryInstructions;
            this.options.PickupInstructions = bootstrap.getBootstrappedData(bootstrap.bootstrapped.DeliveryInfo).PickupInstructions;
            this.options.CanLeaveUnattended = bootstrap.getBootstrappedData(bootstrap.bootstrapped.DeliveryInfo).CanLeaveUnattended;
        }
    }

    getSavedMessage() {
        return this.fulfilmentService.isDelivery() ? this.options.deliveryMessage : this.options.pickupMessage;
    }

    getOptions() {
        return this.api.one('Options').doGET().then((response) => {
            this.options = response;
            return this.options;
        });
    }

    setOptions(options) {
        if (!options) {
            return this.getOptions();
        }

        return this.api.one('Options').doPOST(options).then((response) => {
            this.options = response;

            // Update the mobile phone in the Shopper Service
            if (this.options.MobilePhone) {
                this.shopperService.setMobilePhone(this.options.MobilePhone, false);
            }

            return this.options;
        });
    }
}

DeliveryOptionsService.$inject = ['Restangular', 'BootstrapService', 'ShopperService'];

module.exports = DeliveryOptionsService;



// WEBPACK FOOTER //
// ./src/order/deliveryoptions/delivery-options.service.js